import { Loader2 } from 'lucide-react';
import { cn } from '@/utils/cn';

type Props = {
  className?: string;
  title?: string;
};

export const LoadingIcon = ({ className, title }: Props) => {
  return (
    <Loader2 className={cn('text-gray-400 h-6 w-6 animate-spin', className)} aria-label={title} />
  );
};
